import React from "react";
import "./skins.css";

function payloadRows(payload) {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    return [];
  }
  return Object.entries(payload).slice(0, 6);
}

export default function ItemSummarySkin({ deviceName, displayId, status, latestPayload, latestReceivedAt }) {
  const rows = payloadRows(latestPayload);
  return (
    <section className="skin-card item-summary-skin">
      <header className="skin-card__header">
        <h3>{deviceName || "항목 정보"}</h3>
      </header>
      <div className="skin-card__body item-summary-skin__grid">
        <div>
          <span className="skin-label">표시 ID</span>
          <strong>{displayId || "-"}</strong>
        </div>
        <div>
          <span className="skin-label">상태</span>
          <strong>{status || "-"}</strong>
        </div>
        <div>
          <span className="skin-label">수신</span>
          <strong>{latestReceivedAt || "신호 없음"}</strong>
        </div>
      </div>
      <div className="item-summary-skin__values">
        {!rows.length ? (
          <div className="skin-empty-inline">최근 센서값이 없습니다.</div>
        ) : (
          rows.map(([key, value]) => (
            <div className="item-summary-value" key={key}>
              <span>{key}</span>
              <strong>{String(value)}</strong>
            </div>
          ))
        )}
      </div>
    </section>
  );
}
